<template>
  <div class="upload-detail">
    <MainHeader></MainHeader>
    <div class="main">
      <template v-if="activeList.length > 0">
        <div class="right-mian">
          <div class="item-wrap" v-for="(item, index) in activeList" :key="index" @click="pathTo(item)">
            <div class="item">
              <span class="item-name">{{ item.ExamInforDetailName }}</span>
              <span class="download">下载</span>
            </div>
            <el-divider></el-divider>
          </div>
        </div>
      </template>
      <el-empty v-else description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
export default {
  components: {
    MainHeader
  },
  data() {
    return {
      activeList: [],
      titleIndex: 0,
      inforId: '',
      titleL: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.HJGetExamInforDetail({ inforId: this.$route.query.inforId }).then(res => {
        if (res.Success) {
          console.log(res)
          this.activeList = res.Data
        } else this.$message.error(res.Msg)
      })
    },
    pathTo(item) {
      this.$nextTick(() => {
        window.open(item.DownloadPath, '_blank')
      })
      this.$api.HJUpdateDownloadCount({ detailId: item.ExamInforDetailId }).then(res => { })
    },
  }

}
</script>

<style lang="scss" scoped>
.upload-detail {
  padding-top: 86px;
  height: calc(100% - 37px);
  overflow: auto;
  .main {
    border-radius: 5px;
    background-color: #fff;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    height: calc(100% - 10px);
    overflow: hidden;
    // box-shadow: 0px 12px 20px 0px rgba(208, 208, 208, 0.5);
    box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
    // display: flex;
    .left-mian {
      width: 150px;
      margin: 10px 0;
      .left-item {
        font-size: 16px;
        padding: 20px 10px 20px 13px;
        display: flex;
        justify-content: flex-end;
        text-align: end;
        > p {
          font-size: 16px;
        }
      }
      .act {
        background-color: #49c1d92e;
        border-right: 2px solid #4384f4;
        font-size: 20px;
      }
    }
    .right-mian {
      height: 100%;
      overflow-y: auto;
      padding: 0 10px;
      // width: calc(100% - 150px);
      width: 100%;
      box-shadow: -5px 0 10px -5px rgba(208, 208, 208, 0.5);
      .el-divider--horizontal {
        margin: 10px 0;
        background-color: #eeeeeeaf;
      }
      .item {
        padding: 20px 20px 20px 10px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        span{
          font-size: 15px;
        }
        .item-name:hover{
          color:#4384f4
        }
        .download{
          color: #c2c2c2;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}
</style>